/** Лимиты импорта PDF (согласованы с API PDF_MAX_PAGES / ASSET_MAX_PDF_BYTES). */
export const PDF_MAX_PAGES = 200;
/**
 * Длинная сторона растра страницы (px).
 * Раньше был потолок 1680 с только даунскейлом — слайды оставались ~72 DPI и мылились при зуме.
 * Теперь всегда тянем к этой стороне (~2–3× типичный слайд).
 */
export const PDF_RENDER_MAX_SIDE = 2560;
export const PDF_DEFAULT_FRAME_WIDTH = 640;
